
import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import {
    // HashRouter as Router,
    // Route,
    // Link,
    useHistory
} from "react-router-dom";

import {
    Card,
    Container,
    TextMD,
    TextM,
    TextSM,
    TextGL,
    WhiteSpace,
    Input,
    Button,
    Hr,
    Icon,
    TextLinear,
    FlexBlock,
    // Progress,
    // Hot,
    Tooltip,
    // APR,
    NoData,
    Hot,
    TipsImg
} from '../../components'


// import StakeSeed from './StakeSeed'
// import StakeDialog from '../StakeDialog'
// import Swap, {AddLiquidity} from './Swap'

import {useRelation, useRegist} from '../../hook/pages/useRelation'

import useBalance from '../../hook/pages/useBalance'

// dialog 
import useDialog, {useDialogContext, Dialog2} from '../../hook/useDialog'
// import useInput from '../../hook/useInput'

// import useCopy from '../../hook/useCopy'

import { wFormatInt, splitNumber, BN } from 'web3-sam/dist/BigNumber';
import {utils} from 'web3-sam'
import {getAmountIn} from "../../utils/swap"

// import SvgCircle,{CircleArr} from '../../pageComponents/SvgCircle'

// import {useSmiCountdown} from '../../hook/useCountdown'

// import {
//     useStakeF,
//     useClaimF2,
//     useClaimF1
// } from '../../hook/pages/useStakeF'

const { shortAddress } = utils

// function ClaimF1() {
//     return <Button size='0' {...useClaimF1()}/>
// }
// const ClaimF1Mome = memo(ClaimF1)

// function ClaimF2() {
//     return <Button size='0' {...useClaimF2()}/>
// }
// const ClaimF2Mome = memo(ClaimF2)

function Regist() {
    const {isRegisted, } = useRelation()
    const {
        button,
        recommender
    } = useRegist()
    const {t} = useTranslation();
    return (
        !isRegisted &&
        <Card align='center'>
            <TextMD b='800'>{t("Join Now")}</TextMD>
            <br />
            <TextSM color='2' style={{textAlign: 'center'}}>{t("Joining Cake DAO during the early bird stage, participating in the nodes, and enjoying platform-wide dividends.")}</TextSM>
            <WhiteSpace />
            <Input input={recommender}/>
            <WhiteSpace />
            <Button size='1' w='100' {...button}/>
            <WhiteSpace />
        </Card>
    )
}
export default Regist


export function Referrer() {
    const {recommender} = useRelation()
    return (
        <ReBlock center flex justify='center'>
            <Img src='./icon/referrer.png'/>
            <TextSM>{shortAddress(recommender)}</TextSM>
        </ReBlock>
    )
}

const Img = styled.img`
    display: block;
    width: 14px;
    margin-right: 8px;
`

const ReBlock = styled(FlexBlock)`
    padding: 8px 0px;
    border-radius: 8px;
    background: rgb(248 205 49 / 20%);
    width: 65%;
    margin: 0 auto;
`